import { OverlayTrigger, Tooltip } from "react-bootstrap";

const LoadInventoryToolbar = ({ handleExportToExcel, handleFileUpload, isLockedDownload, fileInputRef }) => {
	return (
		<div className="d-flex justify-content-end">
			<OverlayTrigger placement="left" overlay={<Tooltip id="tooltip-download-template">Descarga un template para cargas masivas</Tooltip>}>
				<button disabled={isLockedDownload} className="ml-3 btn bg-agro-outline" onClick={handleExportToExcel}>
					<i className="fa-solid fa-download pr-2"></i>Plantilla
				</button>
			</OverlayTrigger>

			<input
				type="file"
				accept=".xlsx, .xls"
				onChange={handleFileUpload}
				style={{ display: "none" }}
				id="file-upload"
				ref={fileInputRef}
				className="ml-3"
			/>

			<OverlayTrigger placement="left" overlay={<Tooltip id="tooltip-download-template">Carga el template para una carga masiva</Tooltip>}>
				<label htmlFor="file-upload" className="ml-3 btn bg-agro-outline">
					<i className="fa-solid fa-upload pt-1"></i> Cargar Excel
				</label>
			</OverlayTrigger>
		</div>
	);
};

export default LoadInventoryToolbar;
